import * as React from 'react';
import { Button } from '../Button';
import { Modal, ModalSize } from '../Modal';
import { CartButtonProps } from './CartButton.types';
import './styles/CartButton.css';

export const CartButton = ({
    productId,
    quantity,
    onClick,
    properties,
}: CartButtonProps): JSX.Element => {
    const [ showModal, setShowModal ] = React.useState(false);

    const addToCartTxt = 'Add to cart';

    const onClickHandler = async () => {
        const items = {
            items: [
                {
                  quantity: quantity,
                  id: productId,
                  properties: properties,
                }
            ]
        };
        const response = await fetch('/cart/add.js', {
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(items),
        }); 

        // We May just want to pass a specific message back?
        onClick && onClick(await response.json());
        setShowModal(true);
        //location.reload();
    };

    return (
        <>
            <div className="cart-button-wrapper">
                <Button
                    onClick={onClickHandler}
                    className={`cart-button`}
                >
                    {addToCartTxt}
                </Button>
            </div>
            <Modal
                show={showModal}
                onChange={() => setShowModal(false)}
                size={ModalSize.Small}
            >
                <h2>Successfully added to the cart</h2>
                <p>You can either view your cart or continue browsing.</p>
                <div className="cb-modal__footer">
                    <div>
                        <Button
                            secondary
                            onClick={() => location.reload()}
                        >
                            Continue Shopping
                        </Button>
                        <Button
                            secondary
                            onClick={() => location.replace('/collections/title-badges')}
                        >
                            Search again
                        </Button>
                    </div>
                    <Button
                        onClick={() => location.replace('/cart')}
                        className="go-to-cart"
                    >
                        Go to cart
                    </Button>
                </div>
            </Modal>
        </>
    )
};